import { all, fork } from 'redux-saga/effects';
import { watchAuth } from './features/auth/authSaga';
import type { SagaIterator } from 'redux-saga';
import { watchClients } from './features/clients/clientSaga';
import { watchCustomers } from './features/customers/customerSaga';
import { watchContracts } from './features/contracts/contractSaga';
import { watchEquipment } from './features/equipments/equipmentSaga';
import { watchContractDetails } from './features/contractDetails/contractDetailSaga';
import { watchInsuranceEventDetails } from './features/insuranceDetails/insuranceDetailsSaga';
import { watchNotes } from './features/notes/notesSaga';
import { watchDeficiency } from './features/deficiencies/deficiencySaga';
import { watchPolicyBilling } from './features/policyBilling/policyBillingSaga';

export default function* rootSaga(): SagaIterator {
  yield all([
    fork(watchAuth),
    fork(watchClients),
    fork(watchCustomers),
    fork(watchContracts),
    fork(watchEquipment),
    fork(watchContractDetails),
    fork(watchInsuranceEventDetails),
    fork(watchNotes),
    fork(watchDeficiency),
    fork(watchPolicyBilling),
    // Add other feature sagas here
  ]);
}
